module.exports = __webpack_public_path__ + "media/images/emoticons/libra-5a1ac2774c88aba6b238ab7857b994c1.gif";